<div ngbDropdown class="d-inline-block right me-3">
  <button class="btn btn-primary bg-dark-primary border-0" id="preferencesDropdown" ngbDropdownToggle>
    <span class="fa-user-circle me-2" aria-hidden="true"></span><span>{{ preferenceLabel }}</span>
  </button>
  <div ngbDropdownMenu aria-labelledby="preferencesDropdown" class="dropdown-menu dropdown-menu-right">
    <button ngbDropdownItem class="dropdown-item" (click)="displayHelpdeskInfos()">
      Helpdesk
    </button>
    <button ngbDropdownItem class="dropdown-item" (click)="handleLogout()">
      Sign out
      <span class="fa-sign-out ms-2" aria-hidden="true"></span>
    </button>
  </div>
</div>
